<template>
    <div>
        <h2>微信绑定中...</h2>
    </div>
</template>

<script>
import AppConsts from '../../../config/appconst';
export default {
    data() {
        return {
            
        }
    },
    created() {
      let b=localStorage.getItem("bindwx");
    if (b) {
      localStorage.setItem("bindwx", '');
      var code = this.getQueryVariable("code");
      if (code) {
        this.ajax
          .post("/api/TokenAuth/WxOAuthorization", { isBind: true,code:code })
          .then((x) => {
              this.$toast.success('绑定成功');
           setTimeout(()=>{
                location.href = "http://" + location.host + "/#/retailuser";
           },500)
            return;
          });
      }

      return;
    }
  }
}
</script>